import { render, staticRenderFns } from "./dangerTable.vue?vue&type=template&id=678694a6&scoped=true&"
import script from "./dangerTable.vue?vue&type=script&lang=ts&"
export * from "./dangerTable.vue?vue&type=script&lang=ts&"
import style0 from "./dangerTable.vue?vue&type=style&index=0&id=678694a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678694a6",
  null
  
)

export default component.exports